<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-content>
    <v-container bg fluid>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent :max-width="info_packet.max_width">
          <template v-slot:activator="{on, attrs}">
            <v-btn color="primary" dark v-bind="attrs" v-on="on"> Open Dialog</v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5"> {{ info_packet.card_heading }}</v-card-title>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  :complete="e1 > item.id"
                  :step="item.id"
                  v-for="item in info_packet.steps"
                  :key="item.id"
                >
                  {{ item.step_name }}
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content
                  :step="item.id"
                  v-for="item in info_packet.steps"
                  :key="item.id"
                >
                  <v-card class="mb-12" color="grey lighten-3" elevation="0">
                    <v-container>
                      <v-row align="center">
                        <v-col>
                          <ul v-for="text_item in item.text" :key="text_item.id">
                            <li>
                              {{ text_item }}
                            </li>
                          </ul>
                        </v-col>
                        <v-col>
                          <v-img :src="item.image"></v-img>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-btn
                    color="primary"
                    @click="
                      info_packet.steps.length === e1 ? (e1 = 1) : (e1 = item.id + 1)
                    "
                  >
                    Back
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="
                      info_packet.steps.length === e1 ? (e1 = 1) : (e1 = item.id + 1)
                    "
                  >
                    Continue
                  </v-btn>
                  <v-btn v-if="e1 == 4" text @click="dialog = false"> Close</v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  // import tradeLeftSideBar from "@/components/trade-dsm-application/tradeLeftSideBar";
  // import tradeFiltersTop from "@/components/trade-dsm-application/tradeFiltersTop";
  export default {
    name: 'tradeSarsNational',
    components: {}, //
    data() {
      return {
        dialog: true,
        e1: 1,
        info_packet: {
          card_heading: 'Opening your Downloaded EXCEL file',
          max_width: 900,
          show_random: true,
          steps: [
            {
              step_name: 'Download',
              id: 1,
              text: [
                // Bullet points in list of string
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
              ],
              image: 'https://picsum.photos/seed/picsum/450/450?grayscale',
            },
            {
              step_name: 'Extract',
              id: 2,
              text: [
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
              ],
              image: 'https://picsum.photos/seed/picsum/450/300?grayscale',
            },
            {
              step_name: 'Open',
              id: 3,
              text: [
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
              ],
              image: 'https://picsum.photos/seed/picsum/450/300?grayscale',
            },
            {
              step_name: 'Close',
              id: 4,
              text: [
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras dictum ipsum ut facilisis pellentesque. Mauris placerat et ipsum non gravida. Phasellus ac turpis sapien. Pellentesque hendrerit iaculis faucibus',
              ],
              image: 'https://picsum.photos/seed/picsum/450/450?grayscale',
            },
          ],
        },
      };
    },
  };
</script>

<style scoped></style>
